export enum EInviteType {
  LOCATION = 'LOCATION',
  LOCATION_GROUP = 'LOCATION_GROUP',
  COMPANY = 'COMPANY',
  COMPANY_GROUP = 'COMPANY_GROUP',
}